import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mlemqtetpdmvmmmdkkpx.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1sZW1xdGV0cGRtdm1tbWRra3B4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc3NDQ1MTAsImV4cCI6MjA1MzMyMDUxMH0.GFbUd-qKNzIjzynTk2TYXmnr-BVWtCG1Tw6fFpxt9bw'

export const supabase = createClient(supabaseUrl, supabaseKey) 